<template>
    <div id="calculateur">
        <div class="container">
            <h1 class="title-calculator">Eco-calculateur </h1>
            <h2 class="subtitle-calculator">comment ça marche ?</h2>
            <div v-if="this.group" v-html="this.group.content"></div>
            <div class="calculateur-steps">
                <div class="calculateur-step">
                    <div class="number">1</div>
                    <div class="calculateur-step-content">
                        <div class="img-step img-step-1"></div>
                        <div class="title">La recette <br/>en bref</div>
                    </div>
                </div>
                <div class="calculateur-step-separator"></div>
                <div class="calculateur-step">
                    <div class="number">2</div>
                    <div class="calculateur-step-content">
                        <div class="img-step img-step-2"></div>
                        <div class="title">J'ajoute des <br/>ingrédients</div>
                    </div>
                </div>
                <div class="calculateur-step-separator"></div>
                <div class="calculateur-step">
                    <div class="number">3</div>
                    <div class="calculateur-step-content">
                        <div class="img-step img-step-3"></div>
                        <div class="title">Je découvre l'impact <br/>de ma recette</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">

            <h3 class="step-title">
                1. La recette en bref
            </h3>

            <section class="step-content recette-bref">
                <div class="row">
                    <div class="col-md-3">
                        <div class="recette-illu"></div>
                    </div>
                    <div class="col-md-9">

                        <label class="input-tilte">Titre de la recette *</label>
                        <input v-model="recipe.name" type="text" placeholder="Ex. : Choux fleur rôti sauce aux herbes"
                               class="form-control"/>

                        <label class="input-tilte">Nombre de couverts pour les quantités ci-dessous</label>

                        <div class="quantity-container">
                            <button @click="decrement">-</button>
                            <input id="quantity" v-model="recipe.nb_couvert" @keypress="restrictFloat($event)"
                                   class="form-control" min="1" type="number" placeholder="1"/>
                            <button @click="increment">+</button>
                        </div>

                        <label class="input-tilte">Les poids dans cette recette sont renseignés en</label>
                        <el-select v-model="recipe.rendement" placeholder="Choisir" class="select-rendement">
                            <el-option label="Brut" :value="1"></el-option>
                            <el-option label="Net" :value="0"></el-option>
                        </el-select>

                        <hr/>

                        <h4 class="details" @click="clickShowMore()">
                            Ajouter des détails supplémentaires
                            <svg class="hegagone" :class="{ 'rotate-180': showMore }" width="15" height="16"
                                 viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.75 6.125L7.5 9.875L11.25 6.125" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>

                        </h4>

                        <transition name="slide">
                            <div class="row " v-if="showMore && userRole">

                                <div class="d-none d-md-block col-md-10" v-if="userRole != 'pro' && userRole != 'pro+'">
                                    <div class="public-radio">

                                        <label class="input-tilte">Public ?</label>

                                        <input class="radio-inline" v-model="recipe.scope_recipe" type="radio"
                                               id="public-oui" name="public" value="public"/>
                                        <label class="package-face package-face-yes"
                                               for="public-oui"><span>Oui</span></label>

                                        <input class="radio-inline" v-model="recipe.scope_recipe" type="radio"
                                               id="public-non" name="public" value="owner"/>
                                        <label class="package-face package-face-no"
                                               for="public-non"><span>Non</span></label>

                                    </div>
                                </div>

                                <div class="col-md-10">
                                    <label class="input-tilte">Etapes</label>
                                    <textarea v-model="recipe.text" id="story" name="story" class="form-control"
                                              placeholder="Ajouter les étapes de votre préparation en allant à la ligne pour chaque étape"></textarea>
                                </div>

                                <div class="col-md-10  details-list">
                                    <div class="d-flex no-gutters">
                                        <div class="col-md-4 col-sm-6">
                                            <label class="input-tilte">Type de plat</label>
                                            <el-select clearable v-model="recipe.category_id"
                                                       placeholder="Sélectionner">
                                                <el-option v-for="(category) in optionsCategories"
                                                           :label="category.name" :key="category.id"
                                                           :value="category.id"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <label class="input-tilte">Catégorie</label>
                                            <el-select clearable multiple v-model="recipe.subcategories_ids"
                                                       placeholder="Sélectionner">
                                                <el-option v-for="(subcategory) in optionsSubcategories"
                                                           :label="subcategory.name" :key="subcategory.id"
                                                           :value="subcategory.id"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <label class="input-tilte">Budget (€)</label>
                                            <el-select clearable v-model="recipe.budget" placeholder="Sélectionner">
                                                <el-option v-for="(budget, index) in optionsBudget"
                                                           :label="budget.label" :key="index"
                                                           :value="budget.value"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <label class="input-tilte">Temps de préparation (min)</label>
                                            <el-select clearable v-model="recipe.preparation_minutes"
                                                       placeholder="Sélectionner">
                                                <el-option v-for="(minutes,index) in optionsMinutes"
                                                           :label="minutes+' minutes'" :key="index"
                                                           :value="minutes"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <label class="input-tilte">Temps de cuisson (min)</label>
                                            <el-select clearable v-model="recipe.cuisson_minutes"
                                                       placeholder="Sélectionner">
                                                <el-option v-for="(minutes, index) in optionsMinutes"
                                                           :label="minutes+' minutes'" :key="index"
                                                           :value="minutes"></el-option>
                                            </el-select>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <label class="input-tilte">Facilité de préparation</label>
                                            <el-select clearable v-model="recipe.facilite" placeholder="Sélectionner">
                                                <el-option v-for="(facilite, index) in optionsFacilite"
                                                           :label="facilite.label" :key="index"
                                                           :value="facilite.value"></el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-10 details-list eco-score-infos">
                                    <div class="d-flex no-gutters">
                                        <div class="col-md-12 col-sm-6">
                                            <div class="package-radio">
                                                <label class="input-tilte">Emballage ?</label>

                                                <template v-if="( userRole == 'admin' || userRole == 'pro+')">
                                                    <input @change="packageChange(true)" class="radio-inline"
                                                           v-model="recipe.package" type="radio" id="package-oui"
                                                           name="package" :value="true"/>
                                                    <label class="package-face package-face-yes"
                                                           for="package-oui"><span>Oui</span></label>

                                                    <input @change="packageChange(false)" class="radio-inline"
                                                           v-model="recipe.package" type="radio" id="package-non"
                                                           name="package" :value="false"/>
                                                    <label class="package-face package-face-no" for="package-non"><span>Non</span></label>
                                                </template>

                                            </div>
                                        </div>
                                        <template v-if="(userRole != 'admin' && userRole != 'pro+')">
                                            <div class="col-md-12 mt-3">
                                                <strong style="width:50%">Réservé aux <a target="_blank"
                                                                                         :href="urlLinkAboPro">abonnements
                                                    pro</a></strong>
                                            </div>
                                        </template>
                                        <template v-if="recipe.package">
                                            <div class="col-md-12 mt-3">
                                                <div class="row" :class="index != 0 ? 'mt-2' : ''"
                                                     v-for="(pack, index) in recipe.packages" :key="index">
                                                    <div class="col-md-4 col-sm-6">
                                                        <el-select clearable v-model="pack.package_type_id"
                                                                   placeholder="Type d'emballage">
                                                            <el-option
                                                                v-for="(packageType, index) in optionsPackageTypes"
                                                                :label="packageType.name" :key="index"
                                                                :value="packageType.id"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div class="col-md-5 col-sm-6">
                                                        <el-input class="w-100 text-left"
                                                                  v-model="pack.package_weight_g"
                                                                  placeholder="Poids en grammes par couvert"></el-input>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6 btn-container">
                                                        <template
                                                            v-if="recipe.packages.length < packageLimit && index == (recipe.packages.length - 1) ">
                                                            <button @click.prevent="addPackage"
                                                                    class="btn btn-info small add-row">Ajouter
                                                            </button>
                                                        </template>
                                                        <template v-if="recipe.packages.length > 1 && index != 0">
                                                            <a @click.prevent="removePackage(index)" href="#"
                                                               class="btn-trash">
                                                                <svg width="16" height="16" viewBox="0 0 16 16"
                                                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M5.99972 2H9.99972M1.90448 5.14286H7.90448H13.9045M12.5712 5.14286L12.1989 11.0129C12.1287 12.065 12.0936 12.5911 11.8664 12.99C11.6663 13.3412 11.3645 13.6235 11.0008 13.7998C10.5877 14 10.0605 14 9.00595 14H6.99349C5.93899 14 5.41174 14 4.99861 13.7998C4.63489 13.6235 4.33311 13.3412 4.13304 12.99C3.90579 12.5911 3.87072 12.065 3.80058 11.0129L3.23782 5.14286"
                                                                        stroke="#246E74" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                            </a>

                                                        </template>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 mt-3" v-if="userRole == 'admin'">
                                                <label class="mb-1"><strong>Emballage Ecobalyse</strong></label>
                                                <div class="row" :class="index != 0 ? 'mt-2' : ''"
                                                     v-for="(pack, index) in recipe.ecobalyse_packagings" :key="'ecopack-' + index">
                                                    <div class="col-md-6 col-sm-6">
                                                        <el-select clearable filterable v-model="pack.ecobalyse_packaging_id"
                                                                   placeholder="Emballage Ecobalyse">
                                                            <el-option
                                                                v-for="option in ecobalysePackagingOptions(pack)"
                                                                :label="option.name" :key="'ecopack-opt-' + option.id"
                                                                :value="option.id"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6">
                                                        <el-input class="w-100 text-left"
                                                                  v-model="pack.quantity"
                                                                  placeholder="Nombre d'unités"></el-input>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6 btn-container">
                                                        <template
                                                            v-if="recipe.ecobalyse_packagings.length < packageLimit && index == (recipe.ecobalyse_packagings.length - 1) ">
                                                            <button @click.prevent="addEcobalysePackaging"
                                                                    class="btn btn-info small add-row">Ajouter
                                                            </button>
                                                        </template>
                                                        <template v-if="recipe.ecobalyse_packagings.length > 1 && index != 0">
                                                            <a @click.prevent="removeEcobalysePackaging(index)" href="#"
                                                               class="btn-trash">
                                                                <svg width="16" height="16" viewBox="0 0 16 16"
                                                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M5.99972 2H9.99972M1.90448 5.14286H7.90448H13.9045M12.5712 5.14286L12.1989 11.0129C12.1287 12.065 12.0936 12.5911 11.8664 12.99C11.6663 13.3412 11.3645 13.6235 11.0008 13.7998C10.5877 14 10.0605 14 9.00595 14H6.99349C5.93899 14 5.41174 14 4.99861 13.7998C4.63489 13.6235 4.33311 13.3412 4.13304 12.99C3.90579 12.5911 3.87072 12.065 3.80058 11.0129L3.23782 5.14286"
                                                                        stroke="#246E74" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                            </a>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>

                                        </template>
                                    </div>
                                </div>

                                <div class="col-md-10 details-list eco-score-infos mt-3">
                                    <div class="d-flex no-gutters">
                                        <div class="col-md-12 col-sm-6">
                                            <div class="delivery-radio">
                                                <label class="input-tilte">Livraison ?</label>
                                                <template v-if="( userRole == 'admin' || userRole == 'pro+')">
                                                    <input @change="deliveryChange(true)" class="radio-inline"
                                                           v-model="recipe.delivery" type="radio" id="delivery-oui"
                                                           name="delivery" :value="true"/>
                                                    <label class="package-face package-face-yes"
                                                           for="delivery-oui"><span>Oui</span></label>

                                                    <input @change="deliveryChange(false)" class="radio-inline"
                                                           v-model="recipe.delivery" type="radio" id="delivery-non"
                                                           name="delivery" :value="false"/>
                                                    <label class="package-face package-face-no"
                                                           for="delivery-non"><span>Non</span></label>
                                                </template>
                                            </div>
                                        </div>
                                        <template v-if="(userRole != 'admin' && userRole != 'pro+')">
                                            <div class="col-md-12 mt-3">
                                                <strong style="width:50%">Réservé aux <a target="_blank"
                                                                                         :href="urlLinkAboPro">abonnements
                                                    pro</a></strong>
                                            </div>
                                        </template>
                                        <template v-if="recipe.delivery">
                                            <div class="col-md-12 mt-3">
                                                <div class="row" :class="index != 0 ? 'mt-2' : ''"
                                                     v-for="(delivery, index) in recipe.deliveries" :key="index">
                                                    <div class="col-md-4 col-sm-6">
                                                        <el-select clearable v-model="delivery.delivery_mode_id"
                                                                   placeholder="Type de transport">
                                                            <el-option
                                                                v-for="(deliveryType, index) in optionsDeliveryModes"
                                                                :label="deliveryType.name" :key="index"
                                                                :value="deliveryType.id"></el-option>
                                                        </el-select>
                                                    </div>
                                                    <div class="col-md-5 col-sm-6">
                                                        <el-input class="w-100 text-left"
                                                                  v-model="delivery.delivery_distance"
                                                                  placeholder="Distance parcourue en KM"></el-input>
                                                    </div>
                                                    <div class="col-md-3 col-sm-6 btn-container">
                                                        <template
                                                            v-if="recipe.deliveries.length < deliveryLimit && index == (recipe.deliveries.length - 1) ">
                                                            <button @click.prevent="addDelivery"
                                                                    class="btn btn-info small add-row">Ajouter
                                                            </button>
                                                        </template>
                                                        <template v-if="recipe.deliveries.length > 1 && index != 0">
                                                            <a @click.prevent="removeDelivery(index)" href="#"
                                                               class="btn-trash">
                                                                <svg width="16" height="16" viewBox="0 0 16 16"
                                                                     fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M5.99972 2H9.99972M1.90448 5.14286H7.90448H13.9045M12.5712 5.14286L12.1989 11.0129C12.1287 12.065 12.0936 12.5911 11.8664 12.99C11.6663 13.3412 11.3645 13.6235 11.0008 13.7998C10.5877 14 10.0605 14 9.00595 14H6.99349C5.93899 14 5.41174 14 4.99861 13.7998C4.63489 13.6235 4.33311 13.3412 4.13304 12.99C3.90579 12.5911 3.87072 12.065 3.80058 11.0129L3.23782 5.14286"
                                                                        stroke="#246E74" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                            </a>

                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <template v-if="( userRole == 'admin')">
                                <div class="col-md-10 details-list eco-score-infos mt-3">
                                    <div class="d-flex no-gutters">
                                        <div class="col-md-12 col-sm-6">
                                            <label class="input-tilte">Transformation Ecobalyse</label>
                                            <el-select clearable class="w-100"
                                                       v-model="recipe.transformation"
                                                       placeholder="Automatique (selon cru/cuit)">
                                                <el-option
                                                    v-for="(label, slug) in optionsTransformations"
                                                    :label="label" :key="slug"
                                                    :value="slug"></el-option>
                                            </el-select>
                                            <small class="text-muted">Sans choix : « Cuisson » est envoyée sur la masse des ingrédients cuits. Un procédé choisi s'applique à la masse totale.</small>
                                        </div>
                                    </div>
                                </div>
                                </template>
                                <template v-if="( userRole == 'admin')">
                                <div class="col-md-10 details-list eco-score-infos mt-3">
                                    <div class="d-flex no-gutters">
                                        <div class="col-md-12 col-sm-6">
                                            <label class="input-tilte">Préparation (consommation finale)</label>
                                            <template v-if="( userRole == 'admin' || userRole == 'pro+')">
                                                <el-select clearable multiple :multiple-limit="2" class="w-100"
                                                           v-model="recipe.preparations"
                                                           placeholder="Techniques de préparation (2 max)">
                                                    <el-option
                                                        v-for="(label, slug) in optionsPreparations"
                                                        :label="label" :key="slug"
                                                        :value="slug"></el-option>
                                                </el-select>
                                            </template>
                                        </div>
                                        <template v-if="(userRole != 'admin' && userRole != 'pro+')">
                                            <div class="col-md-12 mt-3">
                                                <strong style="width:50%">Réservé aux <a target="_blank"
                                                                                         :href="urlLinkAboPro">abonnements
                                                    pro</a></strong>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                </template>

                                <div class="col-md-10">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <template v-if="userRole != 'user'">
                                                <label class="input-tilte" for="picture">Photo</label>
                                                <div>
                                                    <input @change="handleFileUpload" ref="picture" name="picture"
                                                           type="file" class="account-photo" id="picture">
                                                </div>
                                                <div class="photo col-md-6">
                                                    <span class="uploadImg" @click="choiceFile">
                                                        <img :src="recipe.picture_url" v-if="recipe.picture_url">
                                                    </span>
                                                </div>
                                            </template>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="d-none d-md-block"
                                                 v-if="userRole != 'pro' && userRole != 'pro+'">
                                                <label class="input-tilte">Vidéo</label>
                                                <input v-model="recipe.video" type="text" class="form-control"
                                                       placeholder="Saisir l'URL de la vidéo"/> <br/>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </transition>

                    </div>
                </div>


            </section>

            <h3 class="step-title">
                2. J'ajoute des ingrédients un par un
            </h3>

            <section class="step-content ingredient-bref">
                <div class="row">
                    <div class="col-md-3  col-6 ingredient-bref-content" v-for="(type, typeIndex) in types"
                         :key="typeIndex" :class="type.slug">
                        <span class="ingredient-bref-title">{{ type.name.replace(/-/g, '/') }}</span>
                        <span class="ingredient-bref-icone" :class="type.slug"></span>
                        <button v-if="type.showMore" type="button" @click="addRow(type.slug)"
                                :disabled="totalIngredientReached(type.slug) ">
                            Ajouter
                            <svg width="37" height="36" viewBox="0 0 37 36" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <circle cx="18.75" cy="18" r="18" fill="#F18544"/>
                                <path d="M19.25 11.375V23.625M13.125 17.5H25.375" stroke="white" stroke-width="2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </section>

            <section class="ingredient" v-for="(type, typeIndex) in types" :key="typeIndex" :class="type.slug">

                <!--  @click="toggleShowMore(type)" -->
                <h4 :class="type.slug">{{ type.name.replace(/-/g, '/') }}</h4>
                <transition name="slide">

                    <!-- v-if="type.showMore" -->
                    <div class="table">
                        <div class="table-head">
                            <div class="cell first">Ingrédients</div>
                            <div class="cell">Nom personnalisé</div>
                            <div class="cell" v-if="type.fields.cuisson">Cuisson</div>
                            <div class="cell">Label</div>
                            <div class="cell quantity">Quantité</div>
                            <div class="cell unity">Unités</div>
                            <div class="cell">Mode de conservation</div>
                            <div class="cell">
                                <span v-if="type.slug == 'fruit-legume-herbes'">Saisonnalité</span>
                                <a href="http://www.guidedesespeces.org/fr" target="_blank"
                                   v-if="type.slug == 'produits-de-la-mer'">Source: Ethic Océan</a>
                            </div>
                            <div class="cell origin">Provenance</div>
                            <div class="cell co2">gCO2e/couvert</div>
                            <div class="cell last"></div>
                        </div>

                        <!-- MOBILE -->
                        <div class="table-row" v-if="isMobile()" v-for="(ingredient, key) in type.ingredients"
                             :key="key">
                            <div class="cell">
                                <el-autocomplete :debounce="400" :trigger-on-focus="false"
                                                 v-model="ingredient[type.fields['label'].name]"
                                                 :fetch-suggestions="(q, cb) => querySearchAsync(q, cb, type)"
                                                 placeholder="Entrez quelque chose"
                                                 @select="selected => handleSelect(selected, typeIndex, key)">
                                    <template slot-scope="{ item }">
                                        <div class="label">{{ item.label }}</div>
                                    </template>
                                </el-autocomplete>
                            </div>
                            <div class="cell">
                                <div class="rendement-input-wrap">
                                    <span v-if="rendementLabel" class="rendement-hint">{{ rendementLabel }}</span>
                                    <input type="number" @keypress="restrictFloat($event)"
                                           @change="calculGco2e(ingredient, typeIndex, key)"
                                           v-model="ingredient[type.fields['quantity'].name]"
                                           :placeholder="type.fields['quantity'].placeholder">
                                </div>
                            </div>
                            <div class="cell">
                                <el-select @change="calculGco2e(ingredient, typeIndex, key)"
                                           v-model="ingredient[type.fields['quantity_unit'].name]"
                                           :placeholder="type.fields['quantity_unit'].placeholder">
                                    <template v-if="ingredient['options_'+type.fields['quantity_unit'].name]">
                                        <el-option
                                            v-for="(unite) in ingredient['options_'+type.fields['quantity_unit'].name]"
                                            :label="unite.label" :key="unite.value" :value="unite.value"></el-option>
                                    </template>
                                    <template v-else>
                                        <el-option v-for="(unite) in type.fields['quantity_unit'].options"
                                                   :label="unite.label" :key="unite.value"
                                                   :value="unite.value"></el-option>
                                    </template>
                                </el-select>
                            </div>
                            <div class="cell delete">
                                <!-- DELETE -->
                                <div>
                                    <svg viewBox="0 0 40 44" class="icon" style="width:30px; height : 30px">
                                        <use xlink:href="#poubelle"></use>
                                    </svg>
                                </div>
                            </div>
                            <h4 class="details sub-details" @click="clickShowMore()">
                                détails supplémentaires
                                <svg viewBox="0 0 30 30" class="hegagone" style="width:30px; height : 30px">
                                    <use xlink:href="#triangle"></use>
                                </svg>
                            </h4>
                            <div class="open">
                                <div class="cell" v-if="type.fields.cuisson">
                                    <el-select @change="calculGco2e(ingredient, typeIndex, key)"
                                               v-model="ingredient[type.fields['cuisson'].name]"
                                               :placeholder="type.fields['cuisson'].placeholder">
                                        <template v-if="ingredient['options_'+type.fields['cuisson'].name]">
                                            <el-option
                                                v-for="(unite) in ingredient['options_'+type.fields['cuisson'].name]"
                                                :label="unite.label" :key="unite.value"
                                                :value="unite.value"></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option v-for="(unite) in type.fields['cuisson'].options"
                                                       :label="unite.label" :key="unite.value"
                                                       :value="unite.value"></el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <div class="cell">
                                    <el-select clearable @change="calculGco2e(ingredient, typeIndex, key)"
                                               v-model="ingredient[type.fields['label_product'].name]"
                                               :placeholder="type.fields['label_product'].placeholder">
                                        <template v-if="ingredient['options_'+type.fields['label_product'].name]">
                                            <el-option
                                                v-for="(unite) in ingredient['options_'+type.fields['label_product'].name]"
                                                :label="unite.label" :key="unite.value"
                                                :value="unite.value"></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option v-for="(unite) in type.fields['label_product'].options"
                                                       :label="unite.label" :key="unite.value"
                                                       :value="unite.value"></el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <div class="cell">
                                    <el-select @change="calculGco2e(ingredient, typeIndex, key)"
                                               v-model="ingredient[type.fields['mode_conserv'].name]"
                                               :placeholder="type.fields['mode_conserv'].placeholder">
                                        <template v-if="ingredient['options_'+type.fields['mode_conserv'].name]">
                                            <el-option
                                                v-for="(unite) in ingredient['options_'+type.fields['mode_conserv'].name]"
                                                :label="unite.label" :key="unite.value"
                                                :value="unite.value"></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option v-for="(unite) in type.fields['mode_conserv'].options"
                                                       :label="unite.label" :key="unite.value"
                                                       :value="unite.value"></el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <div class="cell">
                                    <el-select @change="calculGco2e(ingredient, typeIndex, key)"
                                               v-model="ingredient[type.fields['saison'].name]"
                                               :placeholder="type.fields['saison'].placeholder">
                                        <template v-if="ingredient['options_'+type.fields['saison'].name]">
                                            <el-option
                                                v-for="(unite) in ingredient['options_'+type.fields['saison'].name]"
                                                :label="unite.label" :key="unite.value"
                                                :value="unite.value"></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option v-for="(unite) in type.fields['saison'].options"
                                                       :label="unite.label" :key="unite.value"
                                                       :value="unite.value"></el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <div class="cell">

                                    <el-select @change="calculGco2e(ingredient, typeIndex, key)"
                                               v-model="ingredient[type.fields['provenance'].name]"
                                               :placeholder="type.fields['provenance'].placeholder">
                                        <template v-if="ingredient['options_'+type.fields['provenance'].name]">
                                            <el-option
                                                v-for="(unite) in ingredient['options_'+type.fields['provenance'].name]"
                                                :label="unite.label" :key="unite.value"
                                                :value="unite.value"></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option v-for="(unite) in type.fields['provenance'].options"
                                                       :label="unite.label" :key="unite.value"
                                                       :value="unite.value"></el-option>
                                        </template>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <!-- Desktop -->
                        <div class="table-row" v-if="!isMobile()" v-for="(ingredient, key) in type.ingredients"
                             :key="key">
                            <div class="cell" v-for="(field, itemKey) in type.fields" :key="itemKey"
                                 v-if="itemKey !== 'cuisson' || type.fields.cuisson">
                                <template v-if="field.type == 'autocomplete'">
                                    <el-tooltip :disabled="!ingredient[field.name]" class="item" effect="light"
                                                :content="ingredient[field.name]" placement="top">
                                        <el-autocomplete :debounce="400" popper-class="popper-label-ingredient"
                                                         :trigger-on-focus="false" v-model="ingredient[field.name]"
                                                         :fetch-suggestions="(q, cb) => querySearchAsync(q, cb, type)"
                                                         placeholder="Saisir"
                                                         @select="selected => handleSelect(selected, typeIndex, key)">
                                            <template slot-scope="{ item }">
                                                <div class="label">{{ item.label }}</div>
                                            </template>
                                        </el-autocomplete>
                                    </el-tooltip>
                                </template>
                                <!-- INPUT TEXT -->
                                <div v-if="field.type == 'text'">
                                    <input type="text" @change="calculGco2e(ingredient, typeIndex, key)"
                                           v-model="ingredient[field.name]" :placeholder="'Saisir'">
                                </div>
                                <!-- INPUT NUMBER -->
                                <div v-if="field.type == 'number'" class="rendement-input-wrap">
                                    <span v-if="itemKey === 'quantity' && rendementLabel" class="rendement-hint">{{ rendementLabel }}</span>
                                    <input type="number" @change="calculGco2e(ingredient, typeIndex, key)"
                                           v-model="ingredient[field.name]" @keypress="restrictFloat($event)"
                                           :placeholder="'Saisir'">
                                </div>
                                <!-- SELECT -->
                                <div v-if="field.type == 'select'">
                                    <el-select
                                        v-if="(field.name != 'pivot_saison' && field.name != 'pivot_cuisson') || (field.name == 'pivot_cuisson') || (field.name == 'pivot_saison' && (ingredient.pivot_mode_conserv == 'a_temperature_ambiante' || ingredient.pivot_mode_conserv == 'refrigere') )  "
                                        :data-value="ingredient[field.name]" :class="'select-'+field.name"
                                        :clearable="field.clearable" @change="calculGco2e(ingredient, typeIndex, key)"
                                        v-model="ingredient[field.name]" placeholder="Choisir">
                                        <template v-if="ingredient['options_'+field.name]">
                                            <el-option v-for="(unite) in ingredient['options_'+field.name]"
                                                       :label="unite.label" :key="unite.value"
                                                       :value="unite.value"></el-option>
                                        </template>
                                        <template v-else>
                                            <el-option v-for="(unite) in field.options" :label="unite.label"
                                                       :key="unite.value" :value="unite.value"></el-option>
                                        </template>
                                    </el-select>
                                </div>
                                <!-- RESULT -->
                                <div v-if="field.type == 'result'">
                                    <span class="turquoise "><strong>{{ displayGco2(ingredient[field.name]) }}</strong></span>
                                </div>
                                <!-- INLINE -->
                                <div v-if="field.type == 'inline'">
                                    <span v-if="field.value">{{ field.value }}</span>
                                    <span :data-value="ingredient[field.name]" :class="field.name"
                                          v-else>{{ ingredient[field.name] }}</span>
                                </div>
                                <!-- DELETE -->
                                <div v-if="field.type == 'delete'">
                                    <a @click.prevent="deleteRow(type.slug, key)" class="link-delete">
                                        <svg width="15" height="14" viewBox="0 0 15 14" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.99972 1H9.99972M1.90448 4.14286H7.90448H13.9045M12.5712 4.14286L12.1989 10.0129C12.1287 11.065 12.0936 11.5911 11.8664 11.99C11.6663 12.3412 11.3645 12.6235 11.0008 12.7998C10.5877 13 10.0605 13 9.00595 13H6.99349C5.93899 13 5.41174 13 4.99861 12.7998C4.63489 12.6235 4.33311 12.3412 4.13304 11.99C3.90579 11.5911 3.87072 11.065 3.80058 10.0129L3.23782 4.14286"
                                                stroke="#246E74" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </transition>
                <button v-if="type.showMore" type="button" class="btn add" @click="addRow(type.slug)"
                        :disabled="totalIngredientReached(type.slug) ">
                    <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.5 0.5V7.5M1 4H8" stroke="#246E74" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    Ajouter un ingrédient
                </button>
            </section>


            <h3 class="step-title">
                3. Je découvre l'impact de ma recette et je l'enregistre
            </h3>

            <section class="step-content recette-bref">
                <div class="row">
                    <div class="col-md-3">
                        <div class="save-illu"></div>
                    </div>
                    <div class="col-md-9 step-content-save">
                        <div>
                            <p class="mb-3" v-if="(userRole == 'admin' || userRole == 'pro+')">Découvrez l'impact de
                                votre recette et ses caractéristiques. <br/>N'oubliez pas de l'enregistrer !</p>
                            <p class="mb-3" v-if="(userRole != 'admin' && userRole != 'pro+')">Passez à la formule Pro
                                pour découvrir l'impact <br/>de votre recette et ajouter plus de détail.</p>
                            <div class="step-buttons">
                                <button class="btn turquoise" v-if="!userRole" @click="displayPopupAbo">Calculer les
                                    impacts
                                </button>
                                <button class="btn turquoise" v-if="userRole" @click="calcul">Calculer les impacts
                                </button>
                                <button v-loading="loadingSave" v-if="userRole" :disabled="loadingSave"
                                        class="btn turquoise turquoise-2" @click="save">Enregistrer
                                </button>
                                <button v-if="recipe.id" class="btn turquoise turquoise-2" @click="openDialogTransform">
                                    Transformer en ingrédient
                                </button>
                                <p class="mt-2 mb-0" v-if="autoCalculAvailable && autoStatusText">
                                    <small :class="autoStatus == 'error' ? 'text-danger' : 'text-muted'">{{ autoStatusText }}</small>
                                </p>
                            </div>

                            <el-alert v-if="error" type="danger" :description="errorMessage" show-icon
                                      :closable="false"></el-alert>


                            <div class="el-alert el-alert--warning is-light">
                                <i class="el-alert__icon el-icon-warning is-big"></i>
                                <div class="el-alert__content">
                                    <p class="el-alert__description">Remplissez tous les champs obligatoires</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <!--Info calcul pour admin-->
            <div v-if="resultCalcul && userRole == 'admin'">
                <div>
                    <small><a href="#" @click.prevent="detailsCalcul = !detailsCalcul"><span v-if="detailsCalcul">Masquer</span><span
                        v-else>Afficher</span> les détails de calcul</a></small>
                    <small v-if="recipe.id" style="margin-left: 10px;">
                        <a :href="'/calculateur/' + recipe.id + '/json'" target="_blank">Voir le JSON du calcul</a>
                    </small>
                </div>
                <template v-if="detailsCalcul">
                    Score Environnemental :
                    <ul>
                        <li v-for="(value, name) in resultCalcul.singlescore" :key="name">{{ name }} : {{ value }}</li>
                    </ul>
                    Climat-score :
                    <ul>
                        <li v-for="(value, name) in resultCalcul.climatscore" :key="name">{{ name }} : {{ value }}</li>
                    </ul>
                    Datas :
                    <json-viewer :value="resultCalcul"></json-viewer>
                </template>
            </div>


            <div class="row no-gutters result" v-if="resultCalcul && (varIsDefined(resultCalcul.totalPoidsRaw) || varIsDefined(resultCalcul.totalPoidsPortion))">
                <div class="col-lg-3 environnement poids">
                    <div class="result-content">
                        <div class="ligne" v-if="varIsDefined(resultCalcul.totalPoidsRaw)">
                            <span class="subtitle">Poids comestible</span>
                            <span class="value"><strong>{{ round(resultCalcul.totalPoidsRaw) }} g</strong></span>
                        </div>
                        <div class="ligne" v-if="varIsDefined(resultCalcul.totalPoidsPortion)">
                            <span class="subtitle">Poids après rendement et cuisson</span>
                            <span class="value"><strong>{{ round(resultCalcul.totalPoidsPortion) }} g</strong></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row no-gutters result" v-if="resultCalcul">
                <!-- colonne 1 -->
                <div class="col-lg-3 environnement">
                    <div class="result-heading" @click.prevent="showMoreEnvironnement = !showMoreEnvironnement">
                        <h2> Score Environnemental </h2>
                        <div class="result-recap">
                            <img v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.singlescore.ecoscore_lettre)" height="36"
                                 :src="'/images/pictos/eco-score-compact-'+data_get(resultCalcul, 'singlescore.ecoscore_lettre', 'e')+'.png'">
                            <span v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.singlescore.ecoscore)">{{
                                    round(data_get(resultCalcul, 'singlescore.ecoscore'))
                                }}/100 </span>
                        </div>
                    </div>

                    <!--  v-if="showMoreEnvironnement" -->
                    <div class="result-content">
                        <div class="ligne">
                            <h5>Impacts environnementaux</h5>
                        </div>
                        <div class="ligne" v-if="varIsDefined(resultCalcul.gCO2e)">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce " style="width:45px; height : 45px">
                                <use xlink:href="#co2"></use>
                            </svg>-->
                            <template v-if="(!userRole || userRole == 'user') && isDomain">
                                <strong style="width:50%">Réservé aux <a target="_blank"
                                                                         :href="urlLinkAboPro">{{ textLinkAboPro }}</a></strong>
                            </template>
                            <span> {{ displayGco2(resultCalcul.gCO2e) }} <span>CO2</span>  </span>
                        </div>
                        <div class="ligne" v-if="
                        resultCalcul.totalPoidsFruitLegumeHerbes &&
                        (resultCalcul.ingredients['fruit-legume-herbes']['totalPoidsSaisons'] ||
                        resultCalcul.ingredients['fruit-legume-herbes']['totalPoidsAllSaisons'])
                        ">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#saison"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbSaisonForcent)]"></div>
                            <span> {{ round(resultCalcul.calcul.nbSaisonForcent) }} % <span>de saison</span></span>
                        </div>
                        <div class="ligne" v-if="resultCalcul.totalPoidsProduitsDeLaMer">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#peche"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbMscForcent)]"></div>
                            <span> {{ round(resultCalcul.calcul.nbMscForcent) }} % pêche durable <span
                                v-if="resultCalcul.totalEspeceMenace"> <svg viewBox="0 0 40 40"
                                                                            class="icon hexagone rose"
                                                                            style="width:15px; height : 15px">
                                <use xlink:href="#hexagone"></use>
                                </svg> Présence de poissons menacés </span></span>
                        </div>
                        <div class="ligne">
                            <h5>Modes de production</h5>
                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#bio"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbBioForcent)]"></div>
                            <span> {{ round(resultCalcul.calcul.nbBioForcent) }} % <span>Bio</span></span>
                        </div>
                        <div class="ligne" v-if="resultCalcul.singlescore.impactLabels">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#label"></use>
                            </svg>-->
                            <div
                                :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbBioForcent, 'bonus')]"></div>
                            <span> Bonus Bio et autres Labels : {{
                                    round(resultCalcul.singlescore.impactLabels)
                                }}</span>
                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#label"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbLabelForcent)]"></div>
                            <span> {{ resultCalcul.calcul.nbLabelForcent }} % <span>Labels</span> </span>

                        </div>
                        <div class="ligne">
                            <h5>Provenance</h5>
                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#local"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbLocalForcent)]"></div>
                            <span> {{
                                    round(resultCalcul.calcul.nbLocalForcent)
                                }} % <span>Produits locaux</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#national"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbFranceForcent)]"></div>
                            <span> {{
                                    round(resultCalcul.calcul.nbFranceForcent)
                                }} % <span>Produits nationaux</span> </span>

                        </div>

                        <template v-if="(userRole == 'admin' || userRole == 'pro+')">
                            <div class="ligne"
                                 v-if="resultCalcul.singlescore.impactsDeliveryMpt || resultCalcul.singlescore.impactsPackage">
                                <h5>Emballage et livraison</h5>
                            </div>

                            <div class="ligne" v-if="resultCalcul.singlescore.impactsDeliveryMpt">
                                <svg viewBox="0 0 35 15" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#delivery"></use>
                                </svg>
                                <div
                                    :class="['circle-badge', getColorPercent(resultCalcul.calcul.singlescoreDeliveryForcent, 'delivery-package')]"></div>
                                <span> La livraison représente moins de  {{
                                        round(resultCalcul.singlescore.singlescoreDeliveryForcent)
                                    }} % <span>de l’impact</span></span>
                            </div>
                            <div class="ligne" v-if="resultCalcul.singlescore.impactsPackage">
                                <svg viewBox="-3 0 35 25" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#package"></use>
                                </svg>
                                <div
                                    :class="['circle-badge', getColorPercent(resultCalcul.calcul.singlescorePackageForcent, 'delivery-package')]"></div>
                                <span> L’emballage représente moins de {{
                                        round(resultCalcul.singlescore.singlescorePackageForcent)
                                    }} % <span>de l’impact</span></span>
                            </div>

                            <div class="ligne"
                                 v-if="resultCalcul.singlescore.impactsTransformationMpt || resultCalcul.singlescore.impactsEcobalysePackagingMpt || resultCalcul.singlescore.impactsPreparationMpt">
                                <h5>Contributions Ecobalyse au single score</h5>
                            </div>
                            <div class="ligne" v-if="resultCalcul.singlescore.impactsTransformationMpt">
                                <span>Transformation ({{ optionsTransformations[resultCalcul.singlescore.transformationSlug] || resultCalcul.singlescore.transformationSlug }}) : <strong>{{ formatMpt(resultCalcul.singlescore.impactsTransformationMpt) }} mPt</strong></span>
                            </div>
                            <div class="ligne" v-if="resultCalcul.singlescore.impactsEcobalysePackagingMpt">
                                <span>Emballages Ecobalyse : <strong>{{ formatMpt(resultCalcul.singlescore.impactsEcobalysePackagingMpt) }} mPt</strong></span>
                            </div>
                            <div class="ligne" v-if="resultCalcul.singlescore.impactsPreparationMpt">
                                <span>Préparation finale : <strong>{{ formatMpt(resultCalcul.singlescore.impactsPreparationMpt) }} mPt</strong></span>
                            </div>
                        </template>

                    </div>
                </div>


                <!-- colonne 2 -->
                <div class="col-lg-4 nutrisante">

                    <div class="result-heading" @click.prevent="showMoreSante = !showMoreSante">
                        <h2> Nutri-score </h2>
                        <div class="result-recap">
                            <template v-if="resultCalcul.version == '2.0'">
                                <img v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.pointbfinalLETTRE)" height="36"
                                     :src="'/images/pictos/nutriscore-'+data_get(resultCalcul, 'calcul.pointbfinalLETTRE', 'e')+'-new.svg'">
                            </template>
                            <template v-else>
                                <img v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.pointbfinalLETTRE)" height="36"
                                     :src="'/images/pictos/nutri-score-'+data_get(resultCalcul, 'calcul.pointbfinalLETTRE', 'e')+'.png'">
                            </template>

                        </div>
                    </div>

                    <!--  v-if="showMoreSante" -->
                    <div class="result-content">
                        <div class="nutriscore-content">
                            <div class="ligne nutri-heading">
                                <span class="subtitle">Nutri-score</span>
                                <span class="value">Pour 100g</span>
                                <span class="value">Par couvert</span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.caloriesExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#kcal"></use>
                                </svg>-->
                                Energie Kcal </span>
                                <span class="value"> {{ resultCalcul.calcul.caloriesExt100 }} Kcal</span>
                                <span class="value"> {{ resultCalcul.calcul.caloriesExt }} Kcal </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.caloriesJExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#kj"></use>
                                </svg>-->
                                Energie KJ </span>
                                <span class="value"> {{ resultCalcul.calcul.caloriesJExt100 }} KJ</span>
                                <span class="value"> {{ resultCalcul.calcul.caloriesJExt }} KJ</span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.matGrassesExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#goutte"></use>
                                </svg>-->
                                Matières grasses </span>
                                <span class="value"> {{ resultCalcul.calcul.matGrassesExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.matGrassesExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.acideGrasExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#acide-gras"></use>
                                </svg>-->
                                dont Acides gras </span>
                                <span class="value"> {{ resultCalcul.calcul.acideGrasExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.acideGrasExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.glucidesExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#glucide"></use>
                                </svg>-->
                                Glucides </span>
                                <span class="value"> {{ resultCalcul.calcul.glucidesExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.glucidesExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.sucreExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#sucre"></use>
                                </svg>-->
                                dont Sucre </span>
                                <span class="value"> {{ resultCalcul.calcul.sucreExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.sucreExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.sucreAjoutesExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#sucre"></use>
                                </svg>-->
                                dont Sucres ajoutés </span>
                                <span class="value"> {{ resultCalcul.calcul.sucreAjoutesExt100 || 0 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.sucreAjoutesExt || 0 }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.fibreExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#fibre"></use>
                                </svg>-->
                                Fibres </span>
                                <span class="value"> {{ resultCalcul.calcul.fibreExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.fibreExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.proteinesExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#proteine"></use>
                                </svg>-->
                                Protéines </span>
                                <span class="value"> {{ resultCalcul.calcul.proteinesExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.proteinesExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.selExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#sel"></use>
                                </svg>-->
                                Sel </span>
                                <span class="value"> {{ resultCalcul.calcul.selExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.selExt }} g </span>
                            </div>
                            <div class="ligne"
                                 v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.IGExt100)">
                                <span class="subtitle">
                                <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                    <use xlink:href="#goutte"></use>
                                </svg>-->
                                Charge glycémique </span>
                                <span class="value"> {{ resultCalcul.calcul.IGExt100 }} g</span>
                                <span class="value"> {{ resultCalcul.calcul.IGExt }} g </span>
                            </div>

                            <!-- Start MICRONUTRIMENTS -->
                            <template v-if="userRole && ['admin', 'pro+'].indexOf(userRole) != -1">
                                <div class="ligne sub-ligne">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Calcium </span>
                                    <span class="value"> {{ resultCalcul.calcul.calciumExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.calciumExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.cuivreExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Cuivre </span>
                                    <span class="value"> {{ resultCalcul.calcul.cuivreExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.cuivreExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.ferExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Fer </span>
                                    <span class="value"> {{ resultCalcul.calcul.ferExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.ferExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.magnesiumExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Magnésium </span>
                                    <span class="value"> {{ resultCalcul.calcul.magnesiumExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.magnesiumExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.manganeseExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Manganèse </span>
                                    <span class="value"> {{ resultCalcul.calcul.manganeseExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.manganeseExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.phosphoreExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Phosphore </span>
                                    <span class="value"> {{ resultCalcul.calcul.phosphoreExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.phosphoreExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.potassiumExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Potassium </span>
                                    <span class="value"> {{ resultCalcul.calcul.potassiumExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.potassiumExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.seleniumExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Sélénium </span>
                                    <span class="value"> {{ resultCalcul.calcul.seleniumExt100 }} µg</span>
                                    <span class="value"> {{ resultCalcul.calcul.seleniumExt }} µg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.zincExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Zinc </span>
                                    <span class="value"> {{ resultCalcul.calcul.zincExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.zincExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.vitamineDExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Vitamine D </span>
                                    <span class="value"> {{ resultCalcul.calcul.vitamineDExt100 }} µg</span>
                                    <span class="value"> {{ resultCalcul.calcul.vitamineDExt }} µg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.vitamineCExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Vitamine C </span>
                                    <span class="value"> {{ resultCalcul.calcul.vitamineCExt100 }} mg</span>
                                    <span class="value"> {{ resultCalcul.calcul.vitamineCExt }} mg </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.vitamineAExt100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Vitamine A </span>
                                    <span class="value"> {{ resultCalcul.calcul.vitamineAExt100 }} µg ER</span>
                                    <span class="value"> {{ resultCalcul.calcul.vitamineAExt }} µg ER </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.omega6Ext100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Acide Linoléique - OMEGA 6 </span>
                                    <span class="value"> {{ resultCalcul.calcul.omega6Ext100 }} g</span>
                                    <span class="value"> {{ resultCalcul.calcul.omega6Ext }} g </span>
                                </div>
                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.calcul.omega3Ext100)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#goutte"></use>
                                    </svg>-->
                                    Acide alpha-linolénique OMEGA 3 </span>
                                    <span class="value"> {{ resultCalcul.calcul.omega3Ext100 }} g</span>
                                    <span class="value"> {{ resultCalcul.calcul.omega3Ext }} g </span>
                                </div>

                                <div class="ligne sub-ligne" v-if="varIsDefined(resultCalcul.listAllergenesString)">
                                    <span class="subtitle">
                                    <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:35px; height : 35px">
                                        <use xlink:href="#attention"></use>
                                    </svg>-->
                                    Allergène(s) </span>
                                    <span class="value"> {{ resultCalcul.listAllergenesString }}</span>
                                </div>
                            </template>
                            <!-- END MICRONUTRIMENTS -->

                        </div> <!-- fin de nutriscore -->
                    </div>

                </div>


                <!-- colone 3 -->
                <div class="col-lg-3 societe">


                    <div class="result-heading" @click.prevent="showMoreSante = !showMoreSante">
                        <h2> Score social </h2>
                        <div class="result-recap">
                            <svg v-if="(userRole == 'admin' || userRole == 'pro+') && varIsDefined(resultCalcul.calcul.pointcfinalLETTRE)" viewBox="0 0 40 44" class="icon"
                                 :class="colorsLetter[data_get(resultCalcul,'calcul.pointcfinalLETTRE', 'e')]"
                                 style="width:vpx; height : 36px">
                                <use
                                    :xlink:href="'#lettre-'+data_get(resultCalcul,'calcul.pointcfinalLETTRE', 'e')"></use>
                            </svg>
                        </div>
                    </div>

                    <!--  v-if="showMoreSocial" -->
                    <div class="result-content">
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#local"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbLocalForcent)]"></div>
                            <span> {{ resultCalcul.calcul.nbLocalForcent }} % <span>produits locaux</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#national"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbFranceForcent)]"></div>
                            <span> {{ resultCalcul.calcul.nbFranceForcent }} % <span>produits nationaux</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#court"></use>
                            </svg>-->
                            <div
                                :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbCircuitCourtForcent)]"></div>
                            <span> {{
                                    resultCalcul.calcul.nbCircuitCourtForcent
                                }} % <span>circuits courts</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#equitable"></use>
                            </svg>-->
                            <div
                                :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbCommerceEquitableForcent)]"></div>
                            <span> {{
                                    resultCalcul.calcul.nbCommerceEquitableForcent
                                }} % <span>commerce équitable</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#bio"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbBioForcent)]"></div>
                            <span> {{ resultCalcul.calcul.nbBioForcent }} % <span>Bio</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#label-rouge"></use>
                            </svg>-->
                            <div
                                :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbLabelRougeForcent)]"></div>
                            <span> {{ resultCalcul.calcul.nbLabelRougeForcent }} % <span>Label Rouge</span> </span>

                        </div>
                        <div class="ligne">
                            <!--<svg viewBox="0 0 55 40" class="icon beige-fonce" style="width:45px; height : 45px">
                                <use xlink:href="#label"></use>
                            </svg>-->
                            <div :class="['circle-badge', getColorPercent(resultCalcul.calcul.nbLabelForcent)]"></div>
                            <span> {{ resultCalcul.calcul.nbLabelForcent }} % <span>Labels</span> </span>

                        </div>
                    </div>

                </div>
            </div>

        </div>
        <el-dialog title="Transformer en ingrédient" :visible.sync="dialogueTransform" width="50%"
                   :close-on-click-modal="false" :close-on-press-escape="false" @closed="closedModalDialog">
            <p>Transformer la recette en ingrédient ?</p>
            <el-alert v-if="transformStatus.already_exists"
                      title="L'ingrédient existe déjà. Vous pouvez soit l'ajouter en plus de l'existant ou écraser l'existant."
                      type="warning"></el-alert>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogueTransform = false">Annuler</el-button>
                <template v-if="transformStatus.already_exists">
                    <el-button :loading="loadingTransform" @click.prevent="transformToIngredient('overide')"
                               type="warning">Écraser</el-button>
                    <el-button :loading="loadingTransform" @click.prevent="transformToIngredient('add')" type="primary">Ajouter</el-button>
                </template>
                <template v-if="!transformStatus.already_exists">
                    <el-button :loading="loadingTransform" @click.prevent="transformToIngredient('add')" type="primary">Confirmer</el-button>
                </template>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import JsonViewer from 'vue-json-viewer'

export default {
    components: {JsonViewer},
    data() {
        return {
            types: [],
            roleCanTransform: ['admin', 'pro+'],
            showMore: false,
            showMoreEnvironnement: false,
            showMoreSante: false,
            showMoreSanteNutriscore: false,
            showMoreSocial: false,
            dialogueTransform: false,
            loadingSave: false,
            errorMessage: null,
            error: false,
            group: null,
            detailsCalcul: false,
            recipeToIngredient: {
                type_id: null
            },
            transformStatus: {
                already_exists: false
            },
            loadingTransform: false,
            rules: {},
            optionsPackageTypes: [],
            optionsEcobalysePackagings: [],
            optionsDeliveryModes: [],
            optionsPreparations: {},
            optionsTransformations: {},
            // Calcul dynamique : état affiché, empreinte des entrées du dernier calcul, séquence des requêtes
            autoStatus: null,
            autoSavedAt: null,
            autoRunning: false,
            autoPending: false,
            lastCalculFingerprint: null,
            calculSeq: 0,
            optionsCategories: [],
            optionsSubcategories: [],
            optionsMinutes: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95],
            optionsFacilite: [{label: 'Facile', value: 1}, {label: 'Moyen', value: 2}, {label: 'Dur', value: 3}],
            optionsBudget: [{label: '€', value: 'EUR'}, {label: '€€', value: 'EUREUR'}, {
                label: '€€€',
                value: 'EUREUREUR'
            },],
            resultCalcul: {
                calcul: {},
                singlescore: {},
                climatscore: {}
            },
            packageLimit: 5,
            deliveryLimit: 3,
            recipe: {
                category_id: null,
                subcategory_id: null,
                preparation_minutes: null,
                cuisson_minutes: null,
                facilite: null,
                budget: null,
                name: null,
                text: null,
                video: null,
                scope_recipe: 'owner',
                nb_couvert: 1,
                rendement: null,
                picture: null,
                picture_url: null,
                package: false,
                packages: [
                    {
                        package_type_id: null,
                        package_weight_g: null
                    }
                ],
                ecobalyse_packagings: [
                    {
                        ecobalyse_packaging_id: null,
                        quantity: null
                    }
                ],
                delivery: false,
                deliveries: [
                    {
                        delivery_mode_id: null,
                        delivery_distance: null
                    }
                ],
                preparations: [],
                transformation: null,
            },
            colorsLetter: {
                a: 'turquoise',
                b: 'kaki',
                c: 'jaune',
                d: 'orange',
                e: 'rouge',
            },
            colorsPercent: {
                'turquoise': [80, 100],
                'kaki': [60, 80],
                'jaune': [40, 60],
                'orange': [20, 40],
                'rose': [0, 20],
            },
            colorsPercentDeliveryPackage: {
                'rose': [80, 100],
                'orange': [60, 80],
                'jaune': [40, 60],
                'kaki': [20, 40],
                'turquoise': [0, 20],
            },
            colorsBonus: {
                'turquoise': [10, 100],
                'kaki': [5, 10],
                'jaune': [0, 5]
            },
            _width: 0,
            urlAboPro: 'https://etiquettable.eco2initiative.com/abonnements/'
        }
    },
    props: {
        recipeId: {
            default: null
        },
        userRole: {
            default: null
        },
        isDomain: {
            default: false
        },
    },
    computed: {
        textLinkAboPro() {
            return this.group || (this.isDomain && !this.userRole) ? 'adhérents ' + this.group.name : 'abonnements pro';
        },
        urlLinkAboPro() {
            return this.group || (this.isDomain && !this.userRole) && 'https://etiquettable.eco2initiative.com/espace-restos/' /*this.group.website*/ ? this.group.website : 'https://etiquettable.eco2initiative.com/abonnements/';
        },
        // Rappel du mode de saisie des poids (cf. select recipe.rendement) sous chaque quantité
        rendementLabel() {
            if (this.recipe.rendement === 1) return 'brute';
            if (this.recipe.rendement === 0) return 'nette';
            return null;
        },
        // Calcul dynamique réservé aux rôles qui peuvent déjà calculer (les `user` gardent le popup abonnement)
        autoCalculAvailable() {
            return ['admin', 'pro', 'pro+'].indexOf(this.userRole) !== -1;
        },
        autoStatusText() {
            if (this.autoStatus == 'calcul') return 'Calcul en cours…';
            if (this.autoStatus == 'save') return 'Enregistrement…';
            if (this.autoStatus == 'error') return 'Erreur lors du calcul ou de l\'enregistrement automatique, réessayez ou utilisez les boutons.';
            if (this.autoStatus == 'saved' && this.autoSavedAt) return 'Résultats à jour, recette enregistrée à ' + this.autoSavedAt + '.';
            if (this.autoStatus == 'calculated') {
                return this.recipe.id ? 'Résultats à jour.' : 'Résultats à jour. Cliquez sur Enregistrer pour créer la recette, elle sera ensuite enregistrée automatiquement.';
            }
            return null;
        },
    },
    watch: {
        types: {
            deep: true,
            handler() {
                this.onInputChange();
            }
        },
        recipe: {
            deep: true,
            handler() {
                this.onInputChange();
            }
        },
    },
    created() {
        // Recalcul 800 ms après la dernière saisie
        this.scheduleAutoCalcul = _.debounce(this.autoCalcul, 800);
    },
    mounted() {
        this._width = window.innerWidth
        window.addEventListener('resize', () => {
            this._width = window.innerWidth
        })
        axios.get('/group/').then((r) => {
            this.group = r.data.data;
        })
        axios.get('/calculateur/' + this.recipeId).then((r) => {
            this.types = r.data.types
            if (r.data.recipe.id) {
                this.recipe = r.data.recipe;
                this.resultCalcul = r.data.recipe.calcul;
                this.types.forEach((type) => {
                    this.recipe.ingredients.forEach((ingredient) => {
                        if (ingredient.type_id == type.id) {
                            this.$nextTick(() => {
                                document.querySelector('.ingredient.' + type.slug).classList.add('active');
                            })
                            return;
                        }
                    })
                })
            }
            // Si la recette ne fixe pas explicitement le choix, pré-remplir avec le réglage du user
            if (this.recipe.rendement === null || this.recipe.rendement === undefined) {
                this.recipe.rendement = r.data.recipe.default_rendement;
            }
            this.optionsCategories = r.data.categories;
            this.optionsSubcategories = r.data.subcategories;
            this.optionsPackageTypes = r.data.packageTypes;
            this.optionsDeliveryModes = r.data.deliveryModes;
            this.optionsPreparations = r.data.preparations || {};
            if (!this.recipe.preparations) {
                this.recipe.preparations = [];
            }
            this.optionsEcobalysePackagings = r.data.ecobalysePackagings || [];
            if (!this.recipe.ecobalyse_packagings || !this.recipe.ecobalyse_packagings.length) {
                this.recipe.ecobalyse_packagings = [{ecobalyse_packaging_id: null, quantity: null}];
            }
            this.optionsTransformations = r.data.transformations || {};
            if (this.recipe.transformation === undefined) {
                this.$set(this.recipe, 'transformation', null);
            }
            // Le chargement initial ne doit pas déclencher de calcul/enregistrement automatique
            this.$nextTick(() => {
                this.lastCalculFingerprint = this.inputFingerprint();
            });
        }).catch((e) => {
            console.error(e)
        }).then(() => {
        })
    },
    methods: {
        restrictFloat(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
                ;
            } else {
                return true;
            }
        },
        deliveryChange(v) {
            if (v && !this.recipe.deliveries.length) {
                this.addDelivery();
            }
        },
        packageChange(v) {
            if (v && !this.recipe.packages.length) {
                this.addPackage();
            }
        },
        addPackage() {
            if (this.recipe.packages.length < this.packageLimit) {
                this.recipe.packages.push({
                    package_type_id: null,
                    package_weight_g: null
                });
            }
        },
        removePackage(index) {
            if (this.recipe.packages.length > 1) {
                this.recipe.packages.splice(index, 1)
            }
        },
        ecobalysePackagingOptions(pack) {
            // Options actives + l'emballage désactivé éventuellement déjà sélectionné
            return this.optionsEcobalysePackagings.filter((o) => o.active || o.id === pack.ecobalyse_packaging_id);
        },
        addEcobalysePackaging() {
            this.recipe.ecobalyse_packagings.push({ecobalyse_packaging_id: null, quantity: null});
        },
        removeEcobalysePackaging(index) {
            this.recipe.ecobalyse_packagings.splice(index, 1);
        },
        addDelivery() {
            if (this.recipe.deliveries.length < this.deliveryLimit) {
                this.recipe.deliveries.push({
                    delivery_mode_id: null,
                    delivery_distance: null
                });
            }
        },
        removeDelivery(index) {
            if (this.recipe.deliveries.length > 1) {
                this.recipe.deliveries.splice(index, 1)
            }
        },
        clickShowMore() {
            if (!this.userRole) {
                this.displayPopupAbo()
            } else {
                this.showMore = !this.showMore
            }
        },
        displayPopupAbo(type) {
            if (type == 'pro') {
                this.$alert('Réservé aux <a target="_blank" href="' + this.urlAboPro + '">abonnements pro</a>', '', {
                    dangerouslyUseHTMLString: true
                });
            } else {
                this.$alert('Réservé aux <a target="_blank" href="' + this.urlLinkAboPro + '">' + this.textLinkAboPro + '</a>', '', {
                    dangerouslyUseHTMLString: true
                });
            }

        },
        handleFileUpload(e) {
            var input = e.target;

            var reader = new FileReader();
            reader.onload = () => {
                var dataURL = reader.result;
                this.recipe.picture_url = dataURL;
            };
            reader.readAsDataURL(input.files[0]);
        },
        isMobile() {
            return this._width <= 992
        },
        getColorPercent(percent, type) {
            let percents = this.colorsPercent;
            if (type == 'delivery-package') {
                percents = this.colorsPercentDeliveryPackage;
            } else if (type == 'bonus') {
                percents = this.colorsBonus;
            }
            for (let color in percents) {
                let from = percents[color][0];
                let to = percents[color][1];
                if (percent >= from && percent <= to) {
                    return color;
                }
            }
            return 'gris';
        },
        querySearchAsync(q, cb, type) {
            if (q.length < 3) {
                cb([])
                return
            }
            axios.get('/ingredients', {params: {q, autocomplete: true, type_id: type.id, order: 'label'}}).then((r) => {
                cb(r.data.data)
            })
        },

        handleSelect(select, indexType, indexIngredient) {
            // $set : l'affectation par index n'est pas réactive en Vue 2 (le calcul automatique ne la verrait pas)
            this.$set(this.types[indexType].ingredients, indexIngredient, select);
        },

        addRow(slug) {
            var type = this.types.find(t => t.slug == slug)
            type.ingredients.push({})
            document.querySelector('.ingredient.' + slug).classList.add('active');
        },

        totalIngredient(slug) {
            var type = this.types.find(t => t.slug == slug)
            return type.ingredients.length
        },

        totalIngredientReached(slug) {
            var total = this.totalIngredient(slug)
            var type = this.types.find(t => t.slug == slug)

            return total >= type.max
        },

        deleteRow(slug, key) {
            var type = this.types.find(t => t.slug == slug)
            type.ingredients.splice(key, 1)

            if (!this.totalIngredient(slug)) {
                //this.addRow( slug )
                document.querySelector('.ingredient.' + slug).classList.remove('active');
            }
        },
        toggleShowMore(type) {
            type.showMore = !type.showMore
        },
        /**
         * Lance le calcul des impacts. options.auto = déclenché par la saisie (pas de confirmation provenance).
         * Renvoie true si le résultat a été appliqué, false sinon (annulation, erreur, réponse obsolète).
         */
        async calcul(options = {}) {
            const auto = !!(options && options.auto);
            if (this.userRole == 'user') {
                if (!auto) {
                    this.displayPopupAbo()
                }
                return false;
            }
            if (!auto) {
                let noProvenance = false;
                this.types.forEach((type) => {
                    type.ingredients.forEach((ingredient) => {
                        if (!ingredient.pivot_provenance) {
                            noProvenance = true
                        }
                    })
                })

                if (noProvenance) {
                    try {
                        await this.$confirm('N\'oubliez pas de renseigner la provenance de vos ingrédients, sinon votre calcul environnemental sera faussé', 'Attention', {
                            confirmButtonText: 'Oui',
                            cancelButtonText: 'Annuler',
                            type: 'warning'
                        })
                    } catch (e) {
                        return false
                    }
                }
            }

            const seq = ++this.calculSeq;
            const fingerprint = this.inputFingerprint();
            this.autoStatus = 'calcul';
            try {
                const r = await axios.post('/calculateur/calcul', {recipe: this.recipe, types: this.types});
                if (seq !== this.calculSeq) {
                    // Une requête plus récente est partie : on ignore cette réponse
                    return false;
                }
                if (r.data.calcul) {
                    this.applyCalculTypes(r.data.types);
                    this.resultCalcul = r.data.calcul;
                }
                this.lastCalculFingerprint = fingerprint;
                this.autoStatus = 'calculated';
                return true;
            } catch (e) {
                console.error(e);
                if (seq === this.calculSeq) {
                    this.autoStatus = 'error';
                }
                return false;
            }
        },
        /**
         * Applique le retour du calcul ligne par ligne (résultat gCO2e, saison) sans remplacer les objets
         * ingrédients : une saisie en cours pendant la requête n'est pas écrasée.
         */
        applyCalculTypes(serverTypes) {
            (serverTypes || []).forEach((serverType, typeIndex) => {
                const localType = this.types[typeIndex];
                if (!localType || !serverType.ingredients) {
                    return;
                }
                serverType.ingredients.forEach((serverIngredient, ingredientIndex) => {
                    let local = null;
                    if (serverIngredient.uniqid) {
                        local = localType.ingredients.find(i => i && i.uniqid === serverIngredient.uniqid);
                    }
                    if (!local) {
                        local = localType.ingredients[ingredientIndex];
                    }
                    if (!local || local.id !== serverIngredient.id) {
                        return;
                    }
                    this.$set(local, 'result', serverIngredient.result);
                    if (serverIngredient.pivot_saison !== undefined && !local.pivot_saison) {
                        this.$set(local, 'pivot_saison', serverIngredient.pivot_saison);
                    }
                });
            });
        },
        /**
         * Empreinte des données d'entrée du calcul (recette sans champs volatils + pivots des ingrédients),
         * valeurs normalisées pour ignorer les différences de type renvoyées par le serveur.
         */
        inputFingerprint() {
            const norm = (v) => {
                if (v === null || v === undefined || v === '') return '';
                if (typeof v === 'boolean') return v ? '1' : '0';
                if (typeof v === 'number') return String(v);
                if (Array.isArray(v)) return v.map(norm);
                if (typeof v === 'object') {
                    const out = {};
                    Object.keys(v).sort().forEach((k) => { out[k] = norm(v[k]); });
                    return out;
                }
                return String(v);
            };
            const recipeKeys = ['category_id', 'subcategories_ids', 'nb_couvert', 'rendement', 'package', 'packages',
                'ecobalyse_packagings', 'delivery', 'deliveries', 'preparations', 'transformation', 'scope_recipe',
                'preparation_minutes', 'cuisson_minutes', 'facilite', 'budget', 'name', 'text', 'video'];
            const recipe = {};
            recipeKeys.forEach((k) => { recipe[k] = norm(this.recipe[k]); });
            const ingredients = this.types.map((type) => (type.ingredients || []).map((ingredient) => {
                if (!ingredient || !ingredient.id) return null;
                const pivot = {id: ingredient.id};
                Object.keys(ingredient).forEach((k) => {
                    if (k.indexOf('pivot_') === 0 && k.indexOf('options_') !== 0) {
                        pivot[k] = norm(ingredient[k]);
                    }
                });
                return pivot;
            }));
            return JSON.stringify({recipe, ingredients});
        },
        hasCalculableIngredient() {
            return this.types.some(type => (type.ingredients || []).some(i => i && i.id && i.pivot_quantity));
        },
        onInputChange() {
            if (!this.autoCalculAvailable || !this.scheduleAutoCalcul) {
                return;
            }
            this.scheduleAutoCalcul();
        },
        /** Calcul automatique (debouncé) puis enregistrement silencieux si la recette existe déjà. */
        async autoCalcul() {
            if (!this.autoCalculAvailable || !this.hasCalculableIngredient()) {
                return;
            }
            if (this.inputFingerprint() === this.lastCalculFingerprint) {
                return;
            }
            if (this.autoRunning || this.loadingSave) {
                this.autoPending = true;
                return;
            }
            this.autoRunning = true;
            try {
                const calculated = await this.calcul({auto: true});
                if (calculated && this.recipe.id && this.recipe.name) {
                    await this.autoSave();
                }
            } finally {
                this.autoRunning = false;
                if (this.autoPending) {
                    this.autoPending = false;
                    this.scheduleAutoCalcul();
                }
            }
        },
        async autoSave() {
            this.autoStatus = 'save';
            try {
                await this.persist({silent: true});
                const now = new Date();
                this.autoSavedAt = ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2);
                this.autoStatus = 'saved';
            } catch (e) {
                console.error(e);
                this.autoStatus = 'error';
            }
        },
        calculGco2e(ingredient, typeKey, ingredientKey) {
            if (!ingredient['pivot_quantity']) {
                return;
            }
            if (this.userRole == 'user') {
                return;
            }
            axios.post('/calculateur-gco2e', {recipe: this.recipe, ingredient}).then((r) => {
                this.types[typeKey].ingredients[ingredientKey].result = r.data.result
            })
        },
        async save() {
            if (this.userRole == 'user') {
                this.displayPopupAbo()
                return;
            }

            this.error = false;
            this.errorMessage = null;
            if (!this.recipe.name) {
                this.errorMessage = 'Vous devez choisir un titre pour votre recette.';
                this.error = true;
                return;
            }

            var calculed = await this.calcul();

            if (calculed === false) {
                return
            }

            try {
                let confirmed = await this.$confirm('Confirmez-vous l\'enregistrement de la recette ?', 'Warning', {
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Annuler',
                    type: 'warning'
                })
            } catch (e) {
                return
            }

            this.loadingSave = true
            try {
                await this.persist({silent: false});
                const now = new Date();
                this.autoSavedAt = ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2);
                this.autoStatus = 'saved';
                this.$notify({
                    title: 'Succès',
                    message: 'Recette bien enregistrée.',
                    type: 'success'
                });
            } catch (e) {
                console.error(e);
                this.$alert('Une erreur est survenue, merci de ressayer plus tard.', 'Erreur', {
                    confirmButtonText: 'Fermer'
                });
            } finally {
                this.loadingSave = false
                if (this.autoPending) {
                    this.autoPending = false;
                    this.scheduleAutoCalcul();
                }
            }
        },
        /**
         * Enregistre la recette (création ou mise à jour).
         * silent = enregistrement automatique : la recette locale n'est pas remplacée par la réponse
         * (pour ne pas écraser une saisie en cours) et la photo n'est pas envoyée.
         */
        async persist(options = {}) {
            const silent = !!(options && options.silent);
            let ingredients = this.types.map((v) => v.ingredients).flat().filter(v => v && v.id);
            if (this.recipe.id) {
                const r = await axios.post('/recipes/' + this.recipe.id, {recipe: this.recipe, ingredients: ingredients});
                if (!silent) {
                    this.recipe = r.data.data;
                    this.$nextTick(() => {
                        this.lastCalculFingerprint = this.inputFingerprint();
                    });
                    this.uploadPicture(r.data.data)
                }
            } else {
                const r = await axios.post('/recipes', {recipe: this.recipe, ingredients: ingredients});
                this.recipe = r.data.data;
                this.$nextTick(() => {
                    this.lastCalculFingerprint = this.inputFingerprint();
                });
                this.uploadPicture(r.data.data)
                window.history.pushState({}, r.data.data.name, '/calculateur/' + r.data.data.slug)
            }
        },
        uploadPicture(recipe) {
            if (this.$refs.picture && this.$refs.picture.files.length) {
                let file = this.$refs.picture.files[0];
                let formData = new FormData();
                formData.append('picture', file);
                axios.post('/recipes/' + this.recipe.id, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then((r) => {
                    this.recipe = r.data.data
                }).catch(() => {

                }).then(() => {
                    this.loadingSave = false
                })
            } else {
                this.loadingSave = false
            }
        },
        openDialogTransform() {
            if (this.userRole == 'user' || this.userRole == 'pro') {
                this.displayPopupAbo('pro')
                return;
            }
            axios.get('/recipes/' + this.recipe.id + '/checkTransform').then((r) => {
                this.transformStatus = r.data;
                this.dialogueTransform = true
            })
        },
        closedModalDialog() {
            this.recipeToIngredient.type_id = null
            this.transformStatus.already_exists = false
        },
        transformToIngredient(mode) {
            this.loadingTransform = true
            axios.post('/recipes/' + this.recipe.id + '/transform', {mode, ...this.recipeToIngredient}).then((r) => {
                this.recipe = r.data.data;
                this.dialogueTransform = false;
            }).catch(() => {

            }).then(() => {
                this.loadingTransform = false;
            })
        },
        choiceFile() {
            document.querySelector('#picture').click()
        },
        increment() {
            this.recipe.nb_couvert++;
        },
        decrement() {
            this.recipe.nb_couvert--;
            if (this.recipe.nb_couvert < 1) {
                this.recipe.nb_couvert = 1;
            }
        },
        round(nb) {
            if (!nb) return 0;
            return Math.round(nb)
        },
        formatMpt(nb) {
            return Number(nb || 0).toFixed(3);
        },
        data_get(target, path, fallback) {
            return data_get(target, path, fallback);
        },
        displayGco2(result) {
            if (!result) {
                return '';
            }
            if (result >= 1000) {
                return Number((result / 1000).toFixed(2)) + 'kg'
            }
            return result + 'g'
        },
        hasIngredientSaison() {
            if ('hasIngredientSaison' in this.resultCalcul) {
                return this.resultCalcul.hasIngredientSaison
            }
            return this.recipe.hasIngredientSaison
        },
        varIsDefined(value) {
            return value !== undefined;
        }
    }
}

</script>
<style lang="scss">
.ingredient + .ingredient {
    margin-top: 25px;
}

svg.icon {
    cursor: pointer;
}

.uploadImg {
    cursor: pointer;
}

.slide-enter-active, .slide-leave-active {
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-active {

    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
}

.slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter, .slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

</style>

